$(document).ready(function(){

    $(document).on('click','.cart-qty-btn', function() {

    var quantity_update= $(this).parents('.mini_cart_qty_div').find('.mini_cart_quantity').val();

    var cart_symbole = $(this).attr('symbol');
    if(cart_symbole == "+")
    {
        quantity_update = parseInt(quantity_update) + 1;
        $('.cart-qty-btn[symbol="-"]').attr("disabled", false);
    }
    if(cart_symbole == "-" )
    {
        if(quantity_update == 1)
        {
             $('.cart-qty-btn[symbol="-"]').attr("disabled", true);
        }
        else
         {
            quantity_update = parseInt(quantity_update) - 1;  
        }   
    }
    
    var qty = quantity_update;
    var varient = $(this).parents('.mini_cart_qty_div').find('.mini_cart_quantity').attr('variant-id');
      
    $(this).parents('.mini_cart_qty_div').find('.mini_cart_quantity').attr('value',quantity_update);
  
    var data = { updates: {} };
    data.updates[varient] = qty;
  
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function() { 
  
          jQuery.getJSON('/cart.js', function(cart) {
              $('.total_cart_qty').text(cart.item_count);
          })
      },
      error: function (error) {
        console.log('Error')
      }
    });
  });

})